module.exports = __webpack_public_path__ + "static/img/team-rule.e54a3b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/springFestival/dialog/team-rule.png
// module id = NDkj
// module chunks = 1